import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Guid, isNotNil, Nillable } from '@web/utils';
import {
  DateComponent,
  DetailsViewComponent,
  NoDataComponent,
} from '@web/shared/ui';
import { WarehouseReceiptStatusComponent } from '../warehouse-receipt-status/warehouse-receipt-status.component';
import { WarehouseReceiptStatus } from '../../enums/warehouse-receipt-status';

@Component({
  selector: 'app-warehouse-receipt-details-attributes',
  imports: [
    DateComponent,
    DetailsViewComponent,
    NoDataComponent,
    WarehouseReceiptStatusComponent,
  ],
  templateUrl: './warehouse-receipt-details-attributes.component.html',
  styleUrl: './warehouse-receipt-details-attributes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReceiptDetailsAttributesComponent {
  public readonly id = input.required<Guid>();
  public readonly receiptedAt = input.required<Date>();
  public readonly createdAt = input.required<Date>();
  public readonly approvedAt = input<Nillable<Date>>();
  public readonly number = input.required<string>();
  public readonly status = input.required<WarehouseReceiptStatus>();
  public readonly comment = input<Nillable<string>>();

  protected readonly isNotNil = isNotNil;
}
